import React, { Component } from 'react';
import APIClient from '../../client';
import HeaderView from '../../widgets/header';
import GroupMenuView from '../../widgets/groupmenu';
import GroupSettingsMenuView from '../../widgets/groupsettingsmenu';
import FooterView from '../../widgets/footer';
import superagent from 'superagent';
import Dropzone from 'react-dropzone';
import './style.css';

class View extends Component {
  constructor(params) {
    super(params);
    this.state = {

      item:             null,
      locality:         params.locality,
      user:             params.user,
      groupuid:         (params.match.params || {}).groupuid || null,
      section:          'loading',

    };
    this.handleUserChange = params.handleUserChange;
    this.inputCaptcha = React.createRef();
    this.inputName = React.createRef();
    this.inputDescription = React.createRef();
    this.inputWebsite = React.createRef();
    this.inputEmail = React.createRef();
    this.inputTel = React.createRef();
    this.inputAddress = React.createRef();
  }
  componentDidMount = async () => {

    // set the groups
    document.title = '' + this.state.groupuid;

    // get the token
    let token = APIClient.getToken();

    // set the call
    let result = null;

    // handle errors
    try {
      result = await APIClient.call({

        path:   '/groups/' + this.state.groupuid,
        query:  {
          token
        }
  
      });
    } catch(err) {
      this.setState({
        section: 'error'
      });
      return;
    }

    if(result.ok !== true) {
      this.setState({
        section: 'notfound'
      });
      return;
    }

    // set the groups
    document.title = 'Settings from ' + result.data.name;

    // handle the item
    this.setState({

      section:      'view',
      item:         result.data,
      name:         result.data.name,
      logo:         result.data.logo,
      visibility:   result.data.visibility,
      summary:      result.data.summary,
      description:  result.data.description,
      email:        result.data.email,
      website:      result.data.website,
      phonenumber:  result.data.phonenumber,
      address:      result.data.address

    });

  }
  onDroppedFile = (files) => {

    // get the token
    let token = APIClient.getToken();

    // set initial state
    this.setState({

      section:        'uploading',
      errorMessage:   null

    }, () => {

      const req = superagent.post(APIClient.getBaseAPIURL() + '/uploads?reason=groups.logo&token=' + token);
      req.attach('file', files[0]);
      req.end(async (err, res) => {
        let data = JSON.parse(res.text);

        await APIClient.call({

          path:     '/groups/' + this.state.item.slug,
          method:   'post',
          form:     {
    
            token,
            logo: data.uid || null
    
          }
    
        });

        this.setState({
          logo:     data.url,
          upload:   data.uid
        });
      })
    });

  }
  handleSubmit = async (e) => {
    if(e) e.preventDefault();
    if(this.state.submitting === true) return;
    let token = APIClient.getToken();
    this.setState({

      submitting:   true,
      submissions:  this.state.submissions + 1

    });
    let result = null;
    try {
      result = await APIClient.call({

        path:     '/groups/' + this.state.item.slug,
        method:   'post',
        form:     {
  
          token,
          name: this.inputName.current.value,
          description: this.inputDescription.current.value,
          email: this.inputEmail.current.value,
          phonenumber: this.inputTel.current.value,
          logo: this.state.upload || null,
          website: this.inputWebsite.current.value,
          address: this.inputAddress.current.value,
          visibility: this.state.visibility
  
        }
  
      });
    } catch(err) {
      this.setState({
        submitting:     false,
        errorMessage:   'Something went wrong, try again in a few seconds...'
      })
      return;
    }

    if(result.ok === false) {
      this.setState({
        submitting:     false,
        errorMessage:   result.data.message
      })
      return;
    }

    if(this.state.item.slug !== result.data.slug) {
      this.props.history.push('/groups/' + result.data.slug + '/settings');
      return;
    }

    this.setState({
      item: result.data,
      submitting: false
    })    
  }
  render() {
    if(this.state.section === 'loading') {
      return (
        <div className="wrapper initialoading-wrapper-bg">
          <HeaderView {...this.props} locality={this.state.locality}  user={this.state.user} state={this.state} />
          <div className="initialoading-inside-wrapper">
            <div className="initialoading">
              <div className="dots">
                <div className="dot dot1"></div>
                <div className="dot dot2"></div>
                <div className="dot dot3"></div>
                <div className="dot dot4"></div>
                <div className="dot5"></div>
              </div>
              <h2 className="initialoading-heading">One sec just loading...</h2>
            </div>
          </div>
          <FooterView locality={this.state.locality} state={this.state} />
        </div>);
    } else if(this.state.section === 'error') {
      return (<div className="wrapper">
                <div className="groupsettings">
                  <div className="container">
                    <div className="groupsettings-inner">
                      <p>Something went wrong</p>
                    </div>
                  </div>
                </div>
              </div>);
    } else if(this.state.section === 'notfound') {
      return (<div>
        <HeaderView {...this.props} section="me" locality={this.state.locality}  user={this.state.user} state={this.state} />
        <div className="wrapper">
          <div className="groupsettings">
            <div className="container">
              <div className="groupsettings-inner">

                <p>No such pet or you are not allowed to access</p>

                <div className="clearfix"></div>

              </div>
            </div>
          </div>
        </div>
        <FooterView locality={this.state.locality} state={this.state} />
      </div>);
    }
    return (
      <div>
        <HeaderView {...this.props} locality={this.state.locality}  user={this.state.user} state={this.state} />
        <GroupMenuView user={this.state.user} group={this.state.item} section="settings"></GroupMenuView>
        <div className="wrapper">
          <div className="groupsettings groupsettings-alt">
            <div className="hero-box">
              <GroupSettingsMenuView user={this.state.user} section="details" group={this.state.item}></GroupSettingsMenuView>
            </div>
            <div className="container">
              <div className="groupsettings-inner">

                <div className="details-box">
                  <Dropzone ref="drop" multiple={false} onDrop={this.onDroppedFile}>
                    {({getRootProps, getInputProps}) => (
                      <div onClick={(e) => {
                        e.stopPropagation();
                      }} className="details-box-preview">
                        <div {...getRootProps()}>
                        <p className="details-box-preview-text">We need a logo for your group</p>
                        <img alt="Logo of Group" src={this.state.logo || 'https://cdn.chipndoodle.com/defaults/record.png'} className="details-box-preview-img" />
                        <input {...getInputProps()} />
                        <p className="details-box-preview-text">Click here to upload logo</p>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <div className="details-box-meta">

                  <form onSubmit={this.handleSubmit} className="details-box-controls">

                    <div className="details-box-control">
                      <div className="details-box-control-label">
                        <label htmlFor="nickname">Name</label>
                      </div>
                      <div className="details-box-control-inputs">
                        <input type="text" defaultValue={this.state.name} ref={this.inputName} />
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="details-box-control">
                      <div className="details-box-control-label">
                        <p>Short summary of who you are and what your group does</p>
                        <label htmlFor="nickname">Description</label>
                      </div>
                      <div className="details-box-control-inputs">
                        <textarea defaultValue={this.state.description || ''} ref={this.inputDescription}></textarea>
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="details-box-control">
                      <div className="details-box-control-label">
                        <label htmlFor="nickname">EMail</label>
                      </div>
                      <div className="details-box-control-inputs">
                        <input type="email" defaultValue={this.state.email} ref={this.inputEmail} />
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="details-box-control">
                      <div className="details-box-control-label">
                        <label htmlFor="nickname">Tel</label>
                      </div>
                      <div className="details-box-control-inputs">
                        <input type="tel" defaultValue={this.state.phonenumber} ref={this.inputTel} />
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="details-box-control">
                      <div className="details-box-control-label">
                        <label htmlFor="nickname">Website</label>
                      </div>
                      <div className="details-box-control-inputs">
                        <input type="text" defaultValue={this.state.website} ref={this.inputWebsite} />
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="details-box-control">
                      <div className="details-box-control-label">
                        <p>We only ever show the city on our searches</p>
                        <label htmlFor="nickname">Address</label>
                      </div>
                      <div className="details-box-control-inputs">
                        <input type="text" defaultValue={this.state.address} ref={this.inputAddress} />
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="add-details-box-control">
                      <div className="add-details-box-control-label">
                        <p>Hidden or not, records will be searhable anyway.</p>
                        <label htmlFor="nickname">Visible on Website?</label>
                      </div>
                      <div className="add-details-box-control-inputs">
                        <div className="add-details-box-control-selectables">
                          <a href="/settings#visibility" onClick={(e) => {
                            if(e) e.preventDefault();
                            this.setState({
                              visibility: 'public'
                            })
                          }} className={"add-details-box-control-selectable" + (this.state.visibility === "public" ? " active" : "")}>PUBLIC</a>
                          <a href="/settings#visibility" onClick={(e) => {
                            if(e) e.preventDefault();
                            this.setState({
                              visibility: 'hidden'
                            })
                          }} className={"add-details-box-control-selectable" + (this.state.visibility === "hidden" ? " active" : "")}>HIDDEN</a>
                          <div className="clearfix"></div>
                        </div>
                      </div>
                      <div className="clearfix"></div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="clearfix"></div>

                    </form>
                      
                    <div className="details-box-toolbar">
                      <button className="details-box-toolbar-action details-box-toolbar-action-right" onClick={this.handleSubmit}>SAVE CHANGES</button>
                      <p className="details-box-toolbar-text"></p>
                      <div className="clearfix"></div>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                
              </div>
            </div>
            
          </div>
        </div>
        <FooterView locality={this.state.locality} state={this.state} />
      </div>
    );
  }
}

export default View;